import React from 'react';

export default function DashboardStyleGuide() {
    // Lightweight placeholder component to satisfy the existing dev route.
    return (
        <div className="container-fluid" style={{ paddingTop: 15 }}>
            <div className="panel panel-default">
                <div className="panel-heading">
                    <h3 className="panel-title">Dashboard Style Guide</h3>
                </div>
                <div className="panel-body">
                    <p className="text-muted" style={{ marginBottom: 0 }}>
                        Dev-only placeholder.
                    </p>
                </div>
            </div>
        </div>
    );
}
